import useUsuarioStore from "../stores/UsuarioStore";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import ColaboradorService from "./ColaboradorService";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import PedidoDeCompraService from "./PedidoDeCompraService";
import PedidoDeCompraItensService from "./PedidoDeCompraItensService";
import PedidoDeCompraParcelasService from "./PedidoDeCompraParcelasService";
import PedidoDeCompraAprovadoresService from "./PedidoDeCompraAprovadoresService";
import UtilArray from "../../../utils/UtilArray.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    //==================================================================//
    //======================= ALTERAR PEDIDO ===========================//
    //==================================================================//
    async alterarPedido(pedidoDeCompraValores = {}){

        let pedidoDeCompra;

        try{

            //==================================================================//
            //==================== Pega o Pedido de Compra =====================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraValores.id);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            //==================================================================//
            //=========== Pega os aprovadores do Pedido de compra ==============//
            //==================================================================//

            let pedidoDeCompraAprovadoresIDs = pedidoDeCompra.data.aprovadores;
 
            let pedidoDeCompraAprovadores = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_APROVADORES, pedidoDeCompraAprovadoresIDs);
            if(pedidoDeCompraAprovadores.status != 200){
                throw pedidoDeCompraAprovadores;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============= Remover Itens do Pedido de Compra ==================//
            //========= Separa Itens do Pedido de Compra para Remover ==========//
            //==================================================================//

            let pedidoDeCompraItensRemover = pedidoDeCompraValores?.itens?.reduce((acc,pedidoDeCompraItemRemover)=>{

                if(pedidoDeCompraItemRemover?.remover == true){

                    acc.push(pedidoDeCompraItemRemover);
                }

                return acc;

            },[]);

            //==================================================================//
            //============= Remover Itens do Pedido de Compra ==================//
            //============== Verifica se Tem Itens para Remover ================//
            //==================================================================//

            let temItensParaRemover = UtilArray.isNotEmpty(pedidoDeCompraItensRemover);

            //==================================================================//
            //============= Remover Itens do Pedido de Compra ==================//
            //================== Retorna de AL para AC =========================//
            //==================================================================//

            if(temItensParaRemover){

                let ordemDeServicoItensRetornarValores = pedidoDeCompraItensRemover.map((pedidoDeCompraItemRemover)=>{

                    return{
                        id: pedidoDeCompraItemRemover.osItemID,
                        status: "AC",
                    }

                });

                let ordemDeServicoItensRetornar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensRetornarValores);
                if(ordemDeServicoItensRetornar.status != 200){
                    throw ordemDeServicoItensRetornar;
                }

            }

            //==================================================================//
            //=============== Remover Itens do Pedido de Compra ================//
            //======== Remove Itens do Array de Pedido de Compra Itens =========//
            //==================================================================//

            if(temItensParaRemover){

                pedidoDeCompraValores.itens = pedidoDeCompraValores.itens.reduce((acc,pedidoDeCompraItem)=>{

                    let pedidoDeCompraItemRemover = pedidoDeCompraItensRemover.find(({id}) => id == pedidoDeCompraItem.id);
                    if(!pedidoDeCompraItemRemover){
                        acc.push(pedidoDeCompraItem)
                    }

                    return acc;

                },[]);

            }

            //==================================================================//
            //============= Remover Itens do Pedido de Compra ==================//
            //================ Cancelar os Itens Removidos =====================//
            //==================================================================//

            if(temItensParaRemover){

                let pedidoDeCompraItensRemoverValores = pedidoDeCompraItensRemover.map((pedidoDeCompraItemRemover)=>{

                    return{
                        id: pedidoDeCompraItemRemover.id,
                        status: "Cancelado"
                    }

                });

                pedidoDeCompraItensRemover = await PedidoDeCompraItensService.alteraItens(pedidoDeCompraItensRemoverValores);
                if(pedidoDeCompraItensRemover.status != 200){
                    throw pedidoDeCompraItensRemover;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            
            //==================================================================//
            //========= Adicionar Cotação Itens ao Pedido de Compra ============//
            //=== Separa Cotação Itens do Pedido de Compra para Adicionar ======//
            //==================================================================//

            let cotacaoItensAdicionar = pedidoDeCompraValores?.itens?.reduce((acc,pedidoDeCompraItem)=>{

                if(pedidoDeCompraItem?.adicionado == true){

                    acc.push(pedidoDeCompraItem);
                }

                return acc;

            },[]);

            //==================================================================//
            //========= Adicionar Cotação Itens ao Pedido de Compra ============//
            //============ Verifica se Tem Itens para Adicionar ================//
            //==================================================================//

            let temItensParaAdicionar = UtilArray.isNotEmpty(cotacaoItensAdicionar);

            //==================================================================//
            //========= Adicionar Cotação Itens ao Pedido de Compra ============//
            //==================== Trás de AC para AL ==========================//
            //==================================================================//

            if(temItensParaAdicionar){

                let ordemDeServicoItensAdicionarValores = cotacaoItensAdicionar.map((cotacaoItemAdicionar)=>{

                    return{
                        id: cotacaoItemAdicionar.osItemID,
                        status: "AL",
                        dataEntrega: UtilDateTime.toFormatUTC({dateTime:cotacaoItemAdicionar.osItemDataEntrega}),
                        quantidadeCompra: cotacaoItemAdicionar.osItemQuantidadeCompra,
                        unidadeCompra: cotacaoItemAdicionar.osItemUnidadeCompra,
                        fornecedor: cotacaoItemAdicionar.osItemFornecedor,
                        fornecedorMaterialFornecido: cotacaoItemAdicionar.osItemFornecedorMaterialFornecido,
                        precoUnitarioComImpostos: cotacaoItemAdicionar.osItemPrecoUnitarioComImpostos,
                        precoUnitarioComImpostosPorcentagemDoDesconto: cotacaoItemAdicionar.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto,
                        precoUnitarioComImpostosComDesconto: cotacaoItemAdicionar.osItemPrecoUnitarioComImpostosComDesconto,
                        precoTotalComImpostos: cotacaoItemAdicionar.osItemPrecoTotalComImpostos,
                        temISS: cotacaoItemAdicionar.osItemTemISS,
                        porcentagemISS: cotacaoItemAdicionar.osItemPorcentagemISS,
                        valorPIS: cotacaoItemAdicionar.osItemValorPIS,
                        valorCOFINS: cotacaoItemAdicionar.osItemValorCOFINS,
                        temICMS: cotacaoItemAdicionar.osItemTemICMS,
                        porcentagemICMS: cotacaoItemAdicionar.osItemPorcentagemICMS,
                        valorICMS: cotacaoItemAdicionar.osItemValorICMS,
                        temIPI: cotacaoItemAdicionar.osItemTemIPI,
                        porcentagemIPI: cotacaoItemAdicionar.osItemPorcentagemIPI,
                        valorIPI: cotacaoItemAdicionar.osItemValorIPI,
                        precoTotalSemImpostosComIPI: cotacaoItemAdicionar.osItemPrecoTotalSemImpostosComIPI,
                        precoTotalComImpostosComIPI: cotacaoItemAdicionar.osItemPrecoTotalComImpostosComIPI,
                    }

                });

                let ordemDeServicoItensAdicionar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensAdicionarValores);
                if(ordemDeServicoItensAdicionar.status != 200){
                    throw ordemDeServicoItensAdicionar;
                }

            }

            //==================================================================//
            //============ Adicionar Itens do Pedido de Compra =================//
            //================== Cria os Itens Adicionados =====================//
            //======= Adiciona Itens no Array de Pedido de Compra Itens ========//
            //==================================================================//

            if(temItensParaAdicionar){

                let pedidoDeCompraItensAdicionarValores = cotacaoItensAdicionar.map((cotacaoItemAdicionar)=>{

                    return{
                        cotacaoDePedidoDeCompraItem: cotacaoItemAdicionar.id,
                        requisicaoDeCompra: cotacaoItemAdicionar.requisicaoDeCompraID,
                        ordemDeServicoItem: cotacaoItemAdicionar.osItemID,
                    }

                });

                let pedidoDeCompraItensAdicionar = await PedidoDeCompraItensService.criaItens(pedidoDeCompraItensAdicionarValores);
                if(pedidoDeCompraItensAdicionar.status != 200){
                    throw pedidoDeCompraItensAdicionar;
                }

                pedidoDeCompraValores.itens = pedidoDeCompraValores.itens.concat(pedidoDeCompraItensAdicionar.data);

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
        
            //============================================================================//
            //=== Alterar Itens do Pedido de Compra que já estavam no Pedido de Compra ===//
            //====================== Separa Itens para alteração =========================//
            //============================================================================//

            let pedidoDeCompraItensAlterar = pedidoDeCompraValores?.itens?.reduce((acc,pedidoDeCompraItem)=>{

                if(pedidoDeCompraItem?.novo == true || pedidoDeCompraItem?.status == "Valido"){

                    acc.push(pedidoDeCompraItem);
                }

                return acc;

            },[]);

            //============================================================================//
            //=== Alterar Itens do Pedido de Compra que já estavam no Pedido de Compra ===//
            //================== Verifica se Tem Itens para Alterar ======================//
            //============================================================================//

            let temItensParaAlterar = UtilArray.isNotEmpty(pedidoDeCompraItensAlterar);

            //============================================================================//
            //=== Alterar Itens do Pedido de Compra que já estavam no Pedido de Compra ===//
            //=========================== Altera os Itens" ===============================//
            //============================================================================//

            if(temItensParaAlterar){

                let ordemDeServicoItensAlterarValores = pedidoDeCompraItensAlterar.map((pedidoDeCompraItem)=>{

                    return{
                        id: pedidoDeCompraItem.osItemID,
                        dataEntrega: UtilDateTime.toFormatUTC({dateTime:pedidoDeCompraItem.osItemDataEntrega}),
                        quantidadeCompra: pedidoDeCompraItem.osItemQuantidadeCompra,
                        unidadeCompra: pedidoDeCompraItem.osItemUnidadeCompra,
                        fornecedor: pedidoDeCompraItem.osItemFornecedor,
                        fornecedorMaterialFornecido: pedidoDeCompraItem.osItemFornecedorMaterialFornecido,
                        precoUnitarioComImpostos: pedidoDeCompraItem.osItemPrecoUnitarioComImpostos,
                        precoUnitarioComImpostosPorcentagemDoDesconto: pedidoDeCompraItem.osItemPrecoUnitarioComImpostosPorcentagemDoDesconto,
                        precoUnitarioComImpostosComDesconto: pedidoDeCompraItem.osItemPrecoUnitarioComImpostosComDesconto,
                        precoTotalComImpostos: pedidoDeCompraItem.osItemPrecoTotalComImpostos,
                        temISS: pedidoDeCompraItem.osItemTemISS,
                        porcentagemISS: pedidoDeCompraItem.osItemPorcentagemISS,
                        valorPIS: pedidoDeCompraItem.osItemValorPIS,
                        valorCOFINS: pedidoDeCompraItem.osItemValorCOFINS,
                        temICMS: pedidoDeCompraItem.osItemTemICMS,
                        porcentagemICMS: pedidoDeCompraItem.osItemPorcentagemICMS,
                        valorICMS: pedidoDeCompraItem.osItemValorICMS,
                        temIPI: pedidoDeCompraItem.osItemTemIPI,
                        porcentagemIPI: pedidoDeCompraItem.osItemPorcentagemIPI,
                        valorIPI: pedidoDeCompraItem.osItemValorIPI,
                        precoTotalSemImpostosComIPI: pedidoDeCompraItem.osItemPrecoTotalSemImpostosComIPI,
                        precoTotalComImpostosComIPI: pedidoDeCompraItem.osItemPrecoTotalComImpostosComIPI,
                    }

                });

                let ordemDeServicoItensAlterar = await OrdemDeServicoItemService.alterarItens(ordemDeServicoItensAlterarValores);
                if(ordemDeServicoItensAlterar.status != 200){
                    throw ordemDeServicoItensAlterar;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============ Remover Parcelas do Pedido de Compra ================//
            //======== Separa Parcelas do Pedido de Compra para Remover ========//
            //==================================================================//

            let pedidoDeCompraParcelasRemover = pedidoDeCompraValores?.parcelas?.reduce((acc,pedidoDeCompraParcelaRemover)=>{

                if(pedidoDeCompraParcelaRemover?.remover == true){

                    acc.push(pedidoDeCompraParcelaRemover);
                }

                return acc;

            },[]);

            //==================================================================//
            //========== Remover Parcelas do Pedido de Compra ==================//
            //=========== Verifica se Tem Parcelas para Remover ================//
            //==================================================================//

            let temParcelasParaRemover = UtilArray.isNotEmpty(pedidoDeCompraParcelasRemover);

            //==================================================================//
            //============ Remover Parcelas do Pedido de Compra ================//
            //===== Remove Parcelas do Array de Pedido de Compra Parecelas =====//
            //==================================================================//

            if(temParcelasParaRemover){

                pedidoDeCompraValores.parcelas = pedidoDeCompraValores.parcelas.reduce((acc,pedidoDeCompraParcela)=>{

                    if(pedidoDeCompraParcela?.remover != true){
                        acc.push(pedidoDeCompraParcela)
                    }

                    return acc;

                },[]);

            }

            //==================================================================//
            //============ Remover Parcelas do Pedido de Compra ================//
            //============== Cancelar as Parcelas Removidas ====================//
            //==================================================================//

            if(temParcelasParaRemover){

                let pedidoDeCompraParcelasRemoverValores = pedidoDeCompraParcelasRemover.map((pedidoDeCompraParcelaRemover)=>{

                    return{
                        id: pedidoDeCompraParcelaRemover.id,
                        status: "Cancelada"
                    }

                });

                pedidoDeCompraParcelasRemover = await PedidoDeCompraParcelasService.alteraParcelas(pedidoDeCompraParcelasRemoverValores);
                if(pedidoDeCompraParcelasRemover.status != 200){
                    throw pedidoDeCompraParcelasRemover;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //============ Adicionar Parcelas ao Pedido de Compra ==============//
            //===== Separa Parcelas para adicionar ao Pedido de Compra =========//
            //==================================================================//

            let pedidoDeCompraParcelasAdicionar = pedidoDeCompraValores?.parcelas?.reduce((acc,pedidoDeCompraParcela)=>{

                if(pedidoDeCompraParcela?.adicionada == true){

                    acc.push(pedidoDeCompraParcela);
                }

                return acc;

            },[]);

            //==================================================================//
            //=========== Adicionar Parcelas ao Pedido de Compra ===============//
            //========== Verifica se Tem Parcelas para Adicionar ================//
            //==================================================================//

            let temParcelasParaAdicionar = UtilArray.isNotEmpty(pedidoDeCompraParcelasAdicionar);

            //==================================================================//
            //============ Adicionar Parcelas ao Pedido de Compra ==============//
            //================== Remove Parcelas de Rascunho ===================//
            //==================================================================//

            if(temParcelasParaAdicionar){

                pedidoDeCompraValores.parcelas = pedidoDeCompraValores?.parcelas?.reduce((acc,pedidoDeCompraParcela)=>{

                    if(pedidoDeCompraParcela?.adicionada != true){

                        acc.push(pedidoDeCompraParcela);
                    }

                    return acc;

                },[]);

            }

            //==================================================================//
            //============ Adicionar Parcelas ao Pedido de Compra ==============//
            //=============== Cria as Parcelas para Adicionar ==================//
            //==================================================================//

            if(temParcelasParaAdicionar){

                let pedidoDeCompraParcelasAdicionarValores = pedidoDeCompraParcelasAdicionar.map((pedidoDeCompraParcelaAdicionar)=>{

                    return{
                        tipo: pedidoDeCompraParcelaAdicionar.tipo,
                        descricao: pedidoDeCompraParcelaAdicionar.descricao,
                        diasVencimento: pedidoDeCompraParcelaAdicionar.diasVencimento,
                        dataEntrega: UtilDateTime.toFormatUTC({dateTime:pedidoDeCompraParcelaAdicionar.dataEntrega}),
                        dataVencimento: UtilDateTime.toFormatUTC({dateTime:pedidoDeCompraParcelaAdicionar.dataVencimento}),
                        percentual: pedidoDeCompraParcelaAdicionar.percentual,
                        valor: pedidoDeCompraParcelaAdicionar.valor,
                        referenciaEvento: pedidoDeCompraParcelaAdicionar.referenciaEvento,
                    }

                });

                pedidoDeCompraParcelasAdicionar = await PedidoDeCompraParcelasService.criaParcelas(pedidoDeCompraParcelasAdicionarValores);
                if(pedidoDeCompraParcelasAdicionar.status != 200){
                    throw pedidoDeCompraParcelasAdicionar;
                }

                pedidoDeCompraValores.parcelas = pedidoDeCompraValores.parcelas.concat(pedidoDeCompraParcelasAdicionar.data);

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //===============================================================================//
            //=== Alterar Parcelas do Pedido de Compra que já estavam no Pedido de Compra ===//
            //===================== Separa Parcelas para alteração ==========================//
            //===============================================================================//

            let pedidoDeCompraParcelasAlterar = pedidoDeCompraValores?.parcelas?.reduce((acc,pedidoDeCompraParcela)=>{

                if(pedidoDeCompraParcela?.nova == true || pedidoDeCompraParcela?.status == "Valido"){

                    acc.push(pedidoDeCompraParcela);
                }

                return acc;

            },[]);

            //===============================================================================//
            //=== Alterar Parcelas do Pedido de Compra que já estavam no Pedido de Compra ===//
            //================= Verifica se Tem Parcelas para Alterar =======================//
            //===============================================================================//

            let temParcelasParaAlterar = UtilArray.isNotEmpty(pedidoDeCompraParcelasAlterar);

            //===============================================================================//
            //=== Alterar Parcelas do Pedido de Compra que já estavam no Pedido de Compra ===//
            //=========================== Altera os Parcelas ================================//
            //===============================================================================//

            if(temParcelasParaAlterar){

                let pedidoDeCompraParcelasAdicionarValores = pedidoDeCompraParcelasAlterar.map((pedidoDeCompraParcelaAlterar)=>{

                    return{
                        id: pedidoDeCompraParcelaAlterar.id,
                        tipo: pedidoDeCompraParcelaAlterar.tipo,
                        descricao: pedidoDeCompraParcelaAlterar.descricao,
                        diasVencimento: pedidoDeCompraParcelaAlterar.diasVencimento,
                        dataEntrega: UtilDateTime.toFormatUTC({dateTime:pedidoDeCompraParcelaAlterar.dataEntrega}),
                        dataVencimento: UtilDateTime.toFormatUTC({dateTime:pedidoDeCompraParcelaAlterar.dataVencimento}),
                        percentual: pedidoDeCompraParcelaAlterar.percentual,
                        valor: pedidoDeCompraParcelaAlterar.valor,
                        referenciaEvento: pedidoDeCompraParcelaAlterar.referenciaEvento,
                    }

                });

                let pedidoDeCompraParcelasAdicionar = await PedidoDeCompraParcelasService.alteraParcelas(pedidoDeCompraParcelasAdicionarValores);
                if(pedidoDeCompraParcelasAdicionar.status != 200){
                    throw pedidoDeCompraParcelasAdicionar;
                }

            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //================== Altera o Pedido de Compra =====================//
            //==================================================================//

            let pedidoDeCompraItensIDs = pedidoDeCompraValores.itens.map(({id})=>id);
            let pedidoDeCompraParcelasIDs = pedidoDeCompraValores.parcelas.map(({id})=>id);
            pedidoDeCompraAprovadoresIDs = pedidoDeCompraAprovadores.data.map(({id})=>id);

            pedidoDeCompraValores = {
                id: pedidoDeCompraValores.id,
                fornecedor: pedidoDeCompraValores.fornecedor,
                fornecedorVendedor: pedidoDeCompraValores.fornecedorVendedor,
                fornecedorFormaDePagamento: pedidoDeCompraValores.fornecedorFormaDePagamento,
                itens: pedidoDeCompraItensIDs,
                parcelas: pedidoDeCompraParcelasIDs,
                aprovadores: pedidoDeCompraAprovadoresIDs,
                observacoesGerais: pedidoDeCompraValores.observacoesGerais,
            }

            pedidoDeCompra = await PedidoDeCompraService.alterarPedido(pedidoDeCompraValores);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra

    },

    //==================================================================//
    //==================== FINALIZA ALTERACAO ==========================//
    //==================================================================//
    async finalizarAlteracao(pedidoDeCompraID = ""){

        let pedidoDeCompra;
        let usuarioStore = useUsuarioStore();

        try{

            //==================================================================//
            //==================== Pega o Pedido de Compra =====================//
            //==================================================================//

            pedidoDeCompra = await ERP.getOneById(Schema.PEDIDO_DE_COMPRA, pedidoDeCompraID);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }

            //==================================================================//
            //============== Pega os itens do Pedido de compra =================//
            //==================================================================//

            let pedidoDeCompraItensIDs = pedidoDeCompra.data.itens;
 
            let pedidoDeCompraItens = await ERP.getManyById(Schema.PEDIDO_DE_COMPRA_ITENS, pedidoDeCompraItensIDs);
            if(pedidoDeCompraItens.status != 200){
                throw pedidoDeCompraItens;
            }

            //==================================================================//
            //==== Pega Ordens de Serviço Item dos Itens do Pedido de Compra ===//
            //==================================================================//

            let ordensDeServicoItemIDs = pedidoDeCompraItens?.data?.map(({ordemDeServicoItem})=>ordemDeServicoItem);

            let ordensDeServicoItem = await ERP.getManyById(Schema.ORDEM_DE_SERVICO_ITENS, ordensDeServicoItemIDs);
            if(ordensDeServicoItem.status != 200){
                throw ordensDeServicoItem;
            }

            //==================================================================//
            //===== Pegas Ordens de Serviços das Ordens de Serviço Item ========//
            //==================================================================//

            let ordensDeServico = await ERP.getManyByValue(Schema.ORDEM_DE_SERVICO, "itens" , ordensDeServicoItemIDs);
            if(ordensDeServico.status != 200){
                throw ordensDeServico;
            }

            //==================================================================//
            //================ Pega Jobs das Ordens de Serviço =================//
            //==================================================================//

            let jobs = ordensDeServico.data.map(({job})=>job);

            jobs = await ERP.getManyById(Schema.JOB, jobs);
            if(jobs.status != 200){
                throw jobs;
            }

            //==================================================================//
            //============ Pega Coordenadores de Contratos dos Jobs ============//
            //==================================================================//

            let cordenadoresDeContratos = jobs.data.map(({collaboradorId})=>collaboradorId);

            cordenadoresDeContratos = await ERP.getManyById(Schema.COLABORADOR, cordenadoresDeContratos);
            if(cordenadoresDeContratos.status != 200){
                throw cordenadoresDeContratos;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //===== Altera Itens das Ordens de Serviço do Pedido de Compra =====//
            //==================================================================//

            let ordensDeServicoItemAlterarValores = ordensDeServicoItem.data.reduce((acc,ordemDeServicoItem)=>{

                if(ordemDeServicoItem.status == "AL"){

                    acc.push({
                        id: ordemDeServicoItem.id,
                        status: "AA"
                    })

                }
                
                return acc;

            },[]);

            let ordensDeServicoItemAlterar = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItemAlterarValores);
            if(ordensDeServicoItemAlterar.status != 200){
                throw ordensDeServicoItemAlterar;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //====== Cancela os antigos Aprovadores do Pedido de Compra ========//
            //==================================================================//

            let pedidoDeCompraAprovadoresCancelarValores = pedidoDeCompra.data.aprovadores.map((pedidoDeCompraAprovador)=>{

                return{
                    id: pedidoDeCompraAprovador,
                    status: "Cancelado"
                }

            });

            let pedidoDeCompraAprovadoresCancelar = await PedidoDeCompraAprovadoresService.alteraAprovadores(pedidoDeCompraAprovadoresCancelarValores);
            if(pedidoDeCompraAprovadoresCancelar.status != 200){
                throw pedidoDeCompraAprovadoresCancelar;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //========= Cria os novos Aprovadores do Pedido de Compra ==========//
            //==================================================================//

            let pedidoDeCompraAprovadoresNovosValores = cordenadoresDeContratos.data.map((coordenadorDeContrato)=>{

                 return{
                    aprovador: coordenadorDeContrato.id,
                }

            });

            let pedidoDeCompraAprovadoresNovos = await PedidoDeCompraAprovadoresService.criaAprovacaoCoordenadores(pedidoDeCompraAprovadoresNovosValores);
            if(pedidoDeCompraAprovadoresNovos.status != 200){
                throw pedidoDeCompraAprovadoresNovos;
            }

            let pedidoDeCompraAprovadoresNovosIDs = pedidoDeCompraAprovadoresNovos.data.map(({id})=>id);

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //======-== Pega Owners dos Aprovadores do Pedido de Compra ==-=====//
            //==================================================================//

            let colaboradoresIDs = pedidoDeCompraAprovadoresNovos.data.map(({aprovador})=>aprovador);

            let colaboradoresOwners = await ColaboradorService.pegaColaboradoresUsuario(colaboradoresIDs);
            if(colaboradoresOwners.status != 200){
                return colaboradoresOwners;
            }

            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
            //<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

            //==================================================================//
            //=================== Altera o Pedido de Compra ====================//
            //==================================================================//

            let pedidoDeCompraValores = {
                id: pedidoDeCompraID,
                status: "Em Aprovação de Coordenadores",
                aprovadores: pedidoDeCompraAprovadoresNovosIDs,
                owners: UtilArray.unique(["23e308ed-4f67-4394-9a77-7228d2992dc3", usuarioStore.usuario.id, ...colaboradoresOwners.data])
            }

            pedidoDeCompra = await PedidoDeCompraService.alterarPedido(pedidoDeCompraValores);
            if(pedidoDeCompra.status != 200){
                throw pedidoDeCompra;
            }


        }catch(e){

            console.log(e);
            return pedidoDeCompra;

        }

        return pedidoDeCompra

    },

}